import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, mergeMap } from 'rxjs';
import { ERROR_HANDLING } from '../actions/error-handling.actions';
import { ProjectUtilService } from '@service/project-util/project-util.service';
import { UtilService } from '@service/util/util.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';

@Injectable({
	providedIn: 'root',
})
export class ErrorHandlingEffects {
	constructor(
		private actions$: Actions<any>,
		private projectUtilService: ProjectUtilService,
		private utilService: UtilService
	) {}

	handleProjectUpdateError$ = createEffect(() =>
		this.actions$.pipe(
			ofType(ERROR_HANDLING.HANDLE_PROJECT_UPDATE_ERROR),
			mergeMap((action) => {
				const { error, defaultErrorMessage, forAdd } = action;
				const errorData = error['error'];
				if (this.projectUtilService.isProjectExistsError(errorData)) {
					this.projectUtilService.showProjectExistsError({ forAdd, error: errorData });
				} else {
					this.utilService.showSnackbar(defaultErrorMessage, SNACKBAR.ERROR, SNACKBAR.ACTION);
				}
				return from([]);
			})
		)
	);
}
